import { useEffect, useState } from "react";
import type { PartnerProgram } from "@/shared-types";
import {
    type CalcIsConfirmationDisabledResult,
    calcIsConfirmationDisabled,
    useMdnLookupResult,
} from "../CustomerVerificationUpdated.helpers";

interface UseIsConfirmationDisabledParams {
    additionalDetailsFormIsValid: boolean;
    customerName: string | undefined;
    customerProgram: PartnerProgram | undefined;
    isEditingVerificationInput: boolean;
    mdn: string;
    sessionId: string;
    showProgramSelection: boolean | undefined;
    verificationFormIsValid: boolean;
    verificationType: "phoneNumber" | "billingAccountNumberAndPin";
}

export const useIsConfirmationDisabled = ({
    additionalDetailsFormIsValid,
    customerName,
    customerProgram,
    isEditingVerificationInput,
    mdn,
    sessionId,
    showProgramSelection,
    verificationFormIsValid,
    verificationType,
}: UseIsConfirmationDisabledParams) => {
    const [result, setResult] = useState<CalcIsConfirmationDisabledResult>({
        isConfirmationDisabled: false,
    });
    const mdnLookupResult = useMdnLookupResult(sessionId);

    useEffect(() => {
        const checkConfirmationDisabled = async () => {
            const result = await calcIsConfirmationDisabled({
                customerName,
                verificationType,
                mdn,
                verificationFormIsValid,
                additionalDetailsFormIsValid,
                isEditingVerificationInput,
                showProgramSelection,
                customerProgram,
                mdnLookupResult,
            });

            setResult(result);
        };

        void checkConfirmationDisabled();
    }, [
        customerName,
        verificationType,
        mdn,
        verificationFormIsValid,
        additionalDetailsFormIsValid,
        isEditingVerificationInput,
        showProgramSelection,
        customerProgram,
        mdnLookupResult,
    ]);

    return result;
};
